import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type LatestNewsProps = {
  /** The classname of the component. */
  className?: string;
  /** The articles to be displayed on latest news section. */
  articleProps: ComponentProps<typeof Card>[];
};

/**
 * Latest news articles that are displayed in LATEST NEWS section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12514&t=yUSesLjRt7lt7Dqq-4
 */
const LatestNews = ({
  className,
  articleProps,
}: LatestNewsProps): React.ReactElement => {
  if (articleProps.length === 0) return <></>;

  const variant: CardVariations = {
    title: {
      color: "text-gray-850 font-lct",
      size: "text-base md:text-lg",
      extraClass: cn("font-semibold leading-125"),
    },
    kicker: {
      color: "text-gray-515",
    },
  };

  return (
    <div className={className} data-testid="latest-news-component">
      <BlockTitle text="LATEST NEWS" rootClassName="mb-1 text-lg md:text-3xl" />

      {articleProps.map((props, index) => {
        return (
          <div key={index + "latest news"}>
            <Card
              {...props}
              variations={variant}
              className="divide-y border-gray-175 py-4"
            />
          </div>
        );
      })}
    </div>
  );
};

export default LatestNews;
